import { apiClient } from "./client";

// 1=Primario, 2=Secundario
export const TipoTurma = { Primario: 1, Secundario: 2 };

// 1=Pai, 2=Mae, 3=Responsavel, 4=AlunoResponsavel
export const CargoResponsavel = {
  Pai: 1,
  Mae: 2,
  Responsavel: 3,
  AlunoResponsavel: 4,
};

export const listarTurmas = (instituicaoId) => {
  const qs = instituicaoId ? `?instituicaoId=${instituicaoId}` : "";
  return apiClient.get(`/turmas${qs}`);
};
export const obterTurma = (id) => apiClient.get(`/turmas/${id}`);
export const criarTurma = (payload) => apiClient.post("/turmas", payload);
export const editarTurma = (id, payload) =>
  apiClient.put(`/turmas/${id}`, payload);
export const removerTurma = (id) => apiClient.delete(`/turmas/${id}`);

// Vínculos
export const listarResponsaveis = (turmaId) =>
  apiClient.get(`/turmas/${turmaId}/responsaveis`);
export const listarAlunos = (turmaId) =>
  apiClient.get(`/turmas/${turmaId}/alunos`);
export const listarCoordenadores = (turmaId) =>
  apiClient.get(`/turmas/${turmaId}/coordenadores`);

export const vincularResponsavel = (turmaId, payload) =>
  apiClient.post(`/turmas/${turmaId}/responsaveis`, payload);
export const vincularAluno = (turmaId, userId) =>
  apiClient.post(`/turmas/${turmaId}/alunos`, { turmaId, userId });
export const desvincularAluno = (turmaId, userId) =>
  apiClient.delete(`/turmas/${turmaId}/alunos/${userId}`);
export const vincularCoordenador = (turmaId, userId) =>
  apiClient.post(`/turmas/${turmaId}/coordenadores`, { turmaId, userId });
export const vincularAlunoResponsavel = (turmaId, payload) =>
  apiClient.post(`/turmas/${turmaId}/aluno-responsavel`, payload);

export const atualizarPermissoesResponsavel = (turmaId, userId, permissoes) =>
  apiClient.put(`/turmas/${turmaId}/responsaveis/${userId}/permissoes`, {
    turmaId,
    userId,
    ...permissoes,
  });

export const desvincularResponsavel = (turmaId, userId) =>
  apiClient.delete(`/turmas/${turmaId}/responsaveis/${userId}`);

export const editarPermissoesResponsavelTurma = (turmaId, userId, payload) =>
  apiClient.put(`/turmas/${turmaId}/responsaveis/${userId}/permissoes`, {
    turmaId,
    userId,
    ...payload,
  });

export const editarCargoContatoResponsavelTurma = (turmaId, userId, payload) =>
  apiClient.put(`/turmas/${turmaId}/responsaveis/${userId}/cargo-contato`, {
    turmaId,
    userId,
    cargo: payload.cargo ?? null,
    contato: payload.contato ?? null,
  });

export function importarLista(turmaId, arquivo) {
  const formData = new FormData();
  formData.append("arquivo", arquivo);
  return apiClient.upload(`/turmas/${turmaId}/importar-lista`, formData);
}
